import React from 'react'
import formatDuration from 'lib/format-duration'
import style from './index.module.scss'

const next_page = require('static/next-page.svg')
const next_page_article = require('static/next-page-article.svg')
interface INextPageProps {
  nextItem: any
}

const NextPage: React.FC<INextPageProps> = ({ nextItem }) => {
  const is_video = nextItem?.video_duration ? true : false

  return (
    <a
      href={`/${is_video ? 'video' : 'article'}/${nextItem?.group_id_str}`}
      target="_self"
      className={style.next}
    >
      <div className={style.page}>
        <p className={style.des}>下一篇</p>
        <div className={style.play}>
          {is_video ? (
            <i className={`DCD_Icon icon_play_1 tw-text-12`} />
          ) : (
            <img src={next_page_article} />
          )}
          <span>
            {is_video ? formatDuration(nextItem?.video_duration) : '文章'}
          </span>
        </div>
      </div>

      <div className={style.bottom}>
        <p className={style.title}>{nextItem?.title}</p>
        <img src={next_page} className={style.img} />
      </div>
    </a>
  )
}
export default NextPage
